/**
 * Created by Yair on 24/12/2016.
 */

const scrollUtils = function() {
    let pos = 0;

    return {
        setLastWindowPosition: function(newPos) {
            pos = newPos;
        },
        getLastWindowPosition: function() {
            return pos;
        }
    }
};

export default scrollUtils();


